// eslint-disable-next-line no-underscore-dangle
import { setCookie } from 'PlugAndPlay/_global/js/cookieHelper';

export default function alertCookie(cookieName) {
    /* https://www.geeksforgeeks.org/how-to-create-hash-from-string-in-javascript/ */
    function stringToHash(string) {
        return string.split('').reduce((hash, char) => {
            return char.charCodeAt(0) + (hash < 6) + (hash < 16) - hash;
        }, 0);
    }

    /* page body offset */
    let pageBodyTopPadding;
    const pageBody = document.querySelector('.page-body');
    if (pageBody) {
        pageBodyTopPadding = parseInt(
            window
                .getComputedStyle(pageBody, null)
                .getPropertyValue('padding-top'),
            10
        );
    }

    /* Language option offset */
    let langAssistBoxOffset;
    const langAssistBox = document.querySelector('.language-assistant');
    if (langAssistBox) {
        langAssistBoxOffset = parseInt(
            window
                .getComputedStyle(langAssistBox, null)
                .getPropertyValue('top'),
            10
        );
    }

    let langAssistBoxTriangleOffset;
    const langAssistBoxTriangle = document.querySelector(
        '.language-assistant__wrapper .svg-icon'
    );
    if (langAssistBoxTriangle) {
        langAssistBoxTriangleOffset = parseInt(
            window
                .getComputedStyle(langAssistBoxTriangle, null)
                .getPropertyValue('top'),
            10
        );
    }
    const langAssistBoxTriangles = document.querySelectorAll(
        '.language-assistant__wrapper .svg-icon'
    );
    // const langAssistWrapper = document.querySelector(
    //     '.language-assistant__wrapper'
    // );

    function hideAlert() {
        document.querySelectorAll('.js-alert-wrapper').forEach((item) => {
            item.classList.add('hide');
        });

        /* adjust .page-body padding-top to account for alert */
        pageBody.style.removeProperty('padding-top');
        /* adjust language-assistant pop-up top to account for alert */
        langAssistBox.style.removeProperty('top');
        langAssistBoxTriangles.forEach((triangle) => {
            triangle.style.removeProperty('top');
        });
        // langAssistWrapper.removeProperty('z-index');
    }

    function showAlert() {
        // document.querySelectorAll('.js-alert-wrapper').classList.remove('hide');
        document.querySelectorAll('.js-alert-wrapper').forEach((item) => {
            item.classList.remove('hide');
        });

        /* adjust .page-body padding-top to account for alert */
        let alertHeight;
        const alerts = document.querySelectorAll('.js-alert-wrapper');

        alerts.forEach((alert) => {
            if (alert.offsetHeight) {
                alertHeight = alert.offsetHeight;
            }
        });

        /* page body offset */
        const newPageBodyTopPadding = pageBodyTopPadding + alertHeight;
        if (pageBody) {
            pageBody.style.paddingTop = `${newPageBodyTopPadding}px`;
        }

        /* language assistant */
        const newLangAssistBoxOffset = langAssistBoxOffset + alertHeight;
        if (langAssistBox) {
            langAssistBox.style.top = `${newLangAssistBoxOffset}px`;
        }

        const newLangAssistBoxTriangleOffset =
            langAssistBoxTriangleOffset + alertHeight;
        if (langAssistBoxTriangle) {
            langAssistBoxTriangles.forEach((triangle) => {
                const tri = triangle;
                tri.style.top = `${newLangAssistBoxTriangleOffset}px`;
            });
        }
        // if (langAssistWrapper) {
        //     langAssistWrapper.style.zIndex = '45';
        // }
    }

    /* on load, get message content, cookie expiry duration */
    const alertMessage = document.querySelector('.alert_message');
    if (!alertMessage) {
        return;
    }
    const messageRaw = alertMessage.innerHTML.trim();
    const messageHash = stringToHash(messageRaw);

    const cookieExpiry =
        document.querySelector('.js-alert-wrapper').dataset.expiryDays;

    /* get existing ComOmbAlert cookie value if present */
    let cookieValueRaw;
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.includes(name)) {
            const arr = c.split('=');
            const valueArr = arr.filter((item) => item !== cookieName);
            cookieValueRaw = valueArr.join('=');
        }
    }

    /* if message stored is different to current, then show */
    if (Number(cookieValueRaw) !== Number(messageHash)) {
        showAlert();
    } else {
        hideAlert();
    }

    /* set Cookie when closing the alert */
    document.querySelectorAll('.js-alert_close').forEach((item) => {
        item.addEventListener('click', () => {
            setCookie(cookieName, messageHash, cookieExpiry);
            hideAlert();
        });
    });
}

alertCookie('ComOmbAlert');
